import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getVendorList = createAsyncThunk(
  "get-vendor",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("vendor/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const createVendor = createAsyncThunk(
  "create-vendor",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("vendor", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const editVendor = createAsyncThunk(
  "edit-vendor",
  async (id, { dispatch }) => {
    try {
      const response = await axios.get(`vendor/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const updateVendor = createAsyncThunk(
  "update-vendor",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`/vendor/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);
export const managePriceVendor = createAsyncThunk(
  "update-vendor",
  async (data, { dispatch }) => {
    try {
      const response = await axios.put(`/vendor/manage-price`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const deleteVendor = createAsyncThunk(
  "delete-vendor",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/vendor/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const deleteVendorContact = createAsyncThunk(
  "delete-contact",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/vendor/contact/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const getLedgerList = createAsyncThunk(
  "get-ledger",
  async ({ data, id }, { dispatch }) => {
    try {
      const response = await axios.get(`report/ledger/${id}`, { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const getProfitLossList = createAsyncThunk(
  "get-profit-loss",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get(`/report/profit-loss/list`, {
        params: data,
      });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const getPaymentReports = createAsyncThunk(
  "get-profit-loss",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get(`/report/payment-reports`, {
        params: data,
      });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const getBalanceSheetList = createAsyncThunk(
  "get-balance-sheet",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get(`/report/balance-sheet/list`, {
        params: data,
      });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const vendorSlice = createSlice({
  name: "vendor",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getVendorList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVendorList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.vendorList ?? [];
        state.perPage = action?.payload?.data?.data?.perPage ?? 1;
        state.total = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getVendorList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default vendorSlice.reducer;
